var React = require('react');

function TwoInOne (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 36.2l1.8-1.5c2.9-2.5 5.2-5.2 5.2-8.5 0-3.6-2.4-6.2-6.9-6.2-2.6 0-5 .9-6.4 2L9 25.3c1-.8 2.5-1.6 4.2-1.6 2.3 0 3.2 1.3 3.2 2.9 0 2.3-2.1 4.5-6.4 8.4l-2.5 2.3V40h13.9v-3.8H14zm34.7-15.9l-5.2 2.5.8 3.4 3.7-1.8h.1V40h4.4V20.3zM27.3 27H30v8.6h-2.7zm1.3-4c-.9 0-1.5.6-1.5 1.4 0 .8.6 1.4 1.5 1.4s1.5-.6 1.5-1.4c0-.8-.5-1.4-1.5-1.4zm8.6 3.8c-1.4 0-2.3.8-2.7 1.4h-.1V27h-2.3c0 .8.1 1.7.1 2.8v5.9h2.7v-5c0-.2 0-.5.1-.7.2-.5.6-1 1.4-1 1 0 1.4.8 1.4 1.9v4.8h2.7v-5.1c-.2-2.6-1.5-3.8-3.3-3.8z"}));
}

TwoInOne.defaultProps = {"viewBox":"0 0 60 60","id":"two-in-one","width":"100%","height":"100%"};

module.exports = TwoInOne;

TwoInOne.default = TwoInOne;
